export default {"src":"/_next/static/media/2.02fd4349.gif","height":720,"width":1280};